<script>
  import { format } from 'svelte-i18n';
  import { Button } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { Input } from '@client/components/input';

  export let action = $format('label.ADD');
  export let items = [];
  export let placeholder = '';
  export let validation = undefined;
  export let validationError = '';
  export let hasErrors = false;

  let refs = [];
  let errors = [];

  const onBlur = (index, value) => {
    let error = false;

    errors[index] = false;

    if (validation) {
      if (value?.length && !validation(value)) {
        errors[index] = true;
        error = true;
      }

      if (error) {
        setTimeout(() => refs.length && refs[index]?.focus(), 100);
        return;
      }
    }
  };

  const onKeyUp = (index) => {
    errors[index] = false;
  };

  const onAdd = () => {
    items = [...items, ''];
    errors = [...errors, false];
    setTimeout(() => refs.length && refs.slice(-1)[0]?.focus(), 100);
  };

  const onRemove = (index) => {
    errors.splice(index, 1);
    errors = [...errors];

    items.splice(index, 1);
    items = [...items];

    const minIndex = Math.max(index - 1, 0);

    setTimeout(() => refs.length && refs[minIndex]?.focus(), 100);
  };

  $: hasErrors = errors.filter(Boolean).length;
</script>

<div class="field-list">
  <ul>
    {#each items as value, index}
      <li>
        <div class="item">
          <Input
            type="text"
            class="raw {errors[index] ? 'error' : ''}"
            {placeholder}
            bind:ref={refs[index]}
            bind:value
            on:keyup={() => onKeyUp(index)}
            on:blur={() => onBlur(index, value)}
          />
          <Icon name="x-circle" on:click={() => onRemove(index)} role="button" tabindex="0" />
        </div>
        {#if errors[index]}
          <div class="error">{validationError}</div>
        {/if}
      </li>
    {/each}
  </ul>
  <div class="action-button">
    <Button color="secondary" size="sm" on:click={onAdd}>
      {@html action}
    </Button>
  </div>
</div>

<style lang="scss" src="./list.scss"></style>
